// eslint-disable-next-line filenames/match-regex
import {PlusIcon, TableIcon} from '@primer/octicons-react'
import {Link, Octicon} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'
import type {AddedToProjectV2Event$key} from './__generated__/AddedToProjectV2Event.graphql'
import {TimelineRow} from './row/TimelineRow'

type AddedToProjectV2EventProps = {
  queryRef: AddedToProjectV2Event$key
  issueUrl: string
}

export function AddedToProjectV2Event({queryRef, issueUrl}: AddedToProjectV2EventProps): JSX.Element {
  const {actor, createdAt, project} = useFragment(
    graphql`
      fragment AddedToProjectV2Event on AddedToProjectV2Event {
        createdAt

        actor {
          ...EventActor
        }
        project {
          title
          url
        }
      }
    `,
    queryRef,
  )

  if (!project) {
    return <></>
  }

  // Once we have support for the project IDs being exposed in GQL we can shift to using the
  // `issueEventExternalUrl` function here for our deep linked timestamp.
  return (
    <TimelineRow highlighted={false} actor={actor} createdAt={createdAt} deepLinkUrl={issueUrl} leadingIcon={PlusIcon}>
      <TimelineRow.Main>
        {`${LABELS.timeline.addedThisTo} `}
        <Octicon icon={TableIcon} />{' '}
        <Link href={project.url} sx={{color: 'fg.default', mr: 1}}>
          {project.title}
        </Link>
      </TimelineRow.Main>
    </TimelineRow>
  )
}

try{ AddedToProjectV2Event.displayName ||= 'AddedToProjectV2Event' } catch {}